import React from "react";
import { useTranslation } from "react-i18next";

import OrgList from "@wc/domain/organizations/components/org-list";
import usePageTitle from "@wc/ui/hooks/page-title";

/**
 * @returns {React.ReactElement} The organizations page
 */
export default function OrgsPage() {
  const { t } = useTranslation();
  usePageTitle(t("org.listTitle"));

  return <OrgList />;
}
